/*eslint-disable max-len*/
export default {
  Error: {
    UAuthError: {
      8: 'User already exists',
      9: 'Missing mandatory field',
      10: 'Invalid user id',
      11: 'Fail to send invitation',
      12: 'Invalid or expired token',
      13: 'Invalid credential'
    }
  },

  Form: {
    Toolbar: {
      Continue: 'Continue',
      Cancel: 'Cancel',
      Edit: 'Edit',
      Delete: 'Delete',
      DelModal: {
        Header: 'Delete Item',
        Body: 'Do you wish to delete this item permanently? If so please click Continue else click on Cancel.'
      }
    },
    Actions: {
      Add: 'Add',
      Save: 'Save',
      Cancel: 'Cancel',
      Close: 'Return',
      Ok: 'Ok'
    },
    Validations: {
      Required: 'Required',
      Invalid: 'Invalid value',
      InvalidRegion: 'Invalid region',
      InvalidEmail: 'Wrong email format',
      MaxLen: 'Maximum characters are {0}',
      MinLen: 'Minimum {0} Characters Required',
      InvalidNum: 'Number only',
      ZeroOrMore: 'Number only (greater than or equal to 0)',
      MoreThanZero: 'Positive Number only (greater than 0)',
    }
  },

  ConfirmModal: {
    Continue: 'Continue',
    Cancel: 'Cancel'
  },

  RegionPicker: {
    region: 'Region',
    command: 'Command'
  },

  MemberBadge: {
    External: 'External',
    Internal: 'Internal'
  },

  MemberOption: {
    member_since: 'Member since',
    already_in_group: 'Already In Group',
  },

  Login: {
    Username: 'Email',
    Password: 'Password',
    Submit: 'Sign in',
    timeOutPanel: {
      header: 'Your session will expire if you remain inactive!',
      body: 'You will be logged out automatically in ',
      unit: 'seconds'
    },
    sessionTimeOutError: 'Your session has expired',
    continueSessionText: 'Continue',
    missingInput: 'You must provide your email and password',

    apiResponseErrors: {
      401: 'Credentials Invalid',
      400: 'Validation Failed'
    }
  },

  ForgotPassword: {
    link: 'Forgot your password?',
    title: 'Forgot Password',
    email: 'Email',
    Send: 'Send',
    Close: 'Close',
    Processing: 'Processing...',
    InvalidEmail: 'Your request for a new password cannot be processed, not a valid email id',
    RequestSent: 'Your request is processed successfully'
  },

  Home: {
    title: 'Apps Home',
    modules: {
      UBLT: 'Bulk Load Tool (UBLT)',
      UBET: 'Bulk Extract Tool (UBET)',
      UFLOW: 'Case Management (UFLOW)',
      USERMNG: 'User Management',
      IMGUPLOADER: 'Image Uploader'
    }
  },

  Editor: {
    theme: 'Theme'
  },

  ContentPermission: {
    NoBLTRolesFound: 'You do not have the permissions required to access any Unity applications. Please contact the <a href="mailto:UnitySupportTeam@DNB.com?subject=Unity Access Request">Unity support team</a>, stating the markets you wish to access',
    WelcomeMessage: 'Welcome to Unity'
  },

  Footer: {
    Terms: 'Terms',
    PrivacyPolicy: 'Privacy Policy',
    Copyright: '© Dun &amp; Bradstreet, Inc. {0}. All Rights Reserved.'
  },

  Header: {
    settings: 'Settings',
    logout: 'Logout',
    title: 'Unity',
    options: 'Options',
    reader: 'D&amp;B Unity',
    wiki: 'Wiki (Help)'
  },

  MultiStep: {
    nextButton: 'Next',
    previousButton: 'Previous',
    nextTextOnFinalActionStep: 'Save'
  },

  FileInput: {
    placeHolder: 'Choose A File'
  },

  menuLinks: {
    main: 'Portal Home',
    UBET: 'Bulk Extract Tool (UBET)',
    UBET_tabs: {
      launcher: 'Launcher'
    },
  },

  SearchGrid: {
    messageSearch: 'Search..',
    messageSearching: 'Searching...',
    messageLoadMore: 'Scroll to load more records',
    messageNoMatches: 'No records matched your query'
  },

  UBET: {
    linkText: 'Launch UBET Here (Opens in a new tab)'
  },

}
